import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';

import {
  BASE_URL,
  API_CENTRAL_URL,
  SETTING_GET,
  SETTING_UPDATE,
  LOBBY_SETTING_GET,
  LOBBY_SETTING_UPDATE,
  M_GET,
  M_PATCH,
  M_POST
} from '@/utils/api';

@Module({ name: 'setting' })
export default class Setting extends VuexModule {
  settingData: any = {
    color: {},
    logo: {}
  };

  lobbySettingData: any = {
    theme: '',
    logo: {}
  };

  @Mutation
  mutateData(settingData: any) {
    this.settingData = settingData;
  }

  @Mutation
  mutateLobbyData(lobbySettingData: any) {
    this.lobbySettingData = lobbySettingData;
  }

  @Action({ commit: 'mutateData', rawError: true })
  async GetData() {
    try {
      const { data } = await axios({
        url: BASE_URL + SETTING_GET,
        method: M_GET
      });

      assertOk(data, 'Fetch setting failed');
      return { ...(data?.data ?? {}) };
    } catch (err: any) {
      throw toError(err, 'Fetch setting failed');
    }
  }

  @Action({ rawError: true })
  async EditSetting(params: Record<string, any>) {
    try {
      const { data } = await axios({
        url: BASE_URL + SETTING_UPDATE,
        data: params,
        method: M_PATCH
      });

      assertOk(data, 'Update setting failed');
      return data?.status ?? data;
    } catch (err: any) {
      throw toError(err, 'Update setting failed');
    }
  }

  @Action({ commit: 'mutateLobbyData', rawError: true })
  async GetLobbyData(prefix: string) {
    try {
      const { data } = await axios({
        url: `${API_CENTRAL_URL}${LOBBY_SETTING_GET}?prefix=${prefix}`,
        method: M_POST
      });

      assertOk(data, 'Fetch lobby setting failed');
      return { ...(data?.data ?? {}) };
    } catch (err: any) {
      throw toError(err, 'Fetch lobby setting failed');
    }
  }

  @Action({ rawError: true })
  async EditLobbySetting(params: Record<string, any>) {
    try {
      const { data } = await axios({
        url: API_CENTRAL_URL + LOBBY_SETTING_UPDATE,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Update lobby setting failed');
      return data?.status ?? data;
    } catch (err: any) {
      throw toError(err, 'Update lobby setting failed');
    }
  }
}
